import React from "react";
import styles from "./style/surveyBlockUniversal.module.css";

const SurveyLikert = ({option, index_option, valStyle, isSelected, onChange, img}) => {
  return (
    <div 
      onClick={() => onChange(index_option)} 
      className={`${styles.likertCon} ${index_option === 5 ? styles.preferNotTo : ''}
      ${isSelected ? styles.LikertActivated : ''}`}
    >
      {index_option !== 5 ?
      <div className={styles.likertUpper}>
        <img alt="survey" className={`${styles.likertImage} ${valStyle === "likert_time" ? styles.likertImageTime : ""}`} src={img}/>
      </div> : ""}
      <div className={styles.lowerLikert}>{option}</div>
    </div>
  );
};

export default SurveyLikert;
